import { render, staticRenderFns } from "./PgaValutazioneOffertaAltriPresaleCreate.vue?vue&type=template&id=36333ec2&"
import script from "./PgaValutazioneOffertaAltriPresaleCreate.vue?vue&type=script&lang=ts&"
export * from "./PgaValutazioneOffertaAltriPresaleCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VFadeTransition,VIcon,VRow,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36333ec2')) {
      api.createRecord('36333ec2', component.options)
    } else {
      api.reload('36333ec2', component.options)
    }
    module.hot.accept("./PgaValutazioneOffertaAltriPresaleCreate.vue?vue&type=template&id=36333ec2&", function () {
      api.rerender('36333ec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/ValutazioneOfferta/Components/PgaValutazioneOffertaAltriPresaleCreate.vue"
export default component.exports